export default __webpack_public_path__ + "static/media/plus.11628207.svg";